// removed by extract-text-webpack-plugin
module.exports = {"container":"App__container__sGqxYo3q","top":"App__top__CQ-A_XLo","sidebar":"App__sidebar__hXjRzSqf","main":"App__main__3buZsuFW","bottom":"App__bottom__1HEXuM40","bottom_left":"App__bottom_left__bOfuCCei","bottom_right":"App__bottom_right__3DKOsbta","rule_package":"App__rule_package__3ZL5wNw4"};


//////////////////
// WEBPACK FOOTER
// ./src/App.scss
// module id = I2I8
// module chunks = 0